import React from 'react';
import { SelectPicker, Button } from 'rsuite';

const ControlPanel = ({ 
    departments, 
    users, 
    selectedDepartment, 
    selectedEmployee, 
    onDepartmentChange, 
    onEmployeeChange,
    isSelectionMode,
    selectedDatesCount,
    onEnterSelectionMode,
    onExitSelectionMode,
    onBatchAddSchedule,
    canManage
}) => {
    return (
        <div className='work-schedule-header'>
            <div className="title">工作班表</div>
            <div className="controls">
                <label>部門：</label>
                <SelectPicker
                    data={[
                        { label: '（全部）', value: null },
                        ...departments.map(dept => ({ label: dept.name, value: dept.id }))
                    ]}
                    value={selectedDepartment}
                    onChange={onDepartmentChange}
                    placeholder="選擇部門"
                    cleanable={false}
                    style={{ width: 200 }}
                />
                <label style={{ marginLeft: 20 }}>員工：</label>
                <SelectPicker
                    data={[
                        { label: '（全部）', value: null },
                        ...users.map(user => ({ label: user.name, value: user.uuid }))
                    ]}
                    value={selectedEmployee}
                    onChange={onEmployeeChange}
                    placeholder="選擇員工"
                    cleanable={false}
                    style={{ width: 200 }}
                />
                
                {canManage && (
                    <div style={{ marginLeft: 20, display: 'flex', gap: '10px', alignItems: 'center' }}>
                        {!isSelectionMode ? (
                            <Button 
                                appearance="primary" 
                                onClick={onEnterSelectionMode}
                                size="sm"
                            >
                                選取
                            </Button>
                        ) : (
                            <>
                                <Button 
                                    appearance="subtle" 
                                    onClick={onExitSelectionMode}
                                    size="sm"
                                >
                                    取消
                                </Button>
                                <Button 
                                    appearance="primary" 
                                    onClick={onBatchAddSchedule}
                                    disabled={selectedDatesCount === 0}
                                    size="sm"
                                >
                                    新增班表 ({selectedDatesCount})
                                </Button>
                            </>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ControlPanel;
